import { useContext } from 'react';
import { FleetTypeRadioGroupContext } from './FleetTypeRadioGroupContext';

export const useFleetTypeRadioGroupContext = () => {
    const context = useContext(FleetTypeRadioGroupContext);
    return context;
};
